import React, { useState, useEffect, useRef } from "react";

import useTable from "../useTableR";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import { ActualizarEfiscal } from "./modalActualizarEfiscal";
import { Toasts } from "../toasts";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "CÓDIGO",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "DESCRIPCIÓN",
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "AÑO",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

const TablaEjFisca2 = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [efiscal, setEfiscal] = useState();
  const [orga, setOrga] = useState();
  const txtBuscador = useRef();
  const permiso = JSON.parse(localStorage.getItem("accefiscal"));
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

    const handleSearch = (e) => {
      let target = e.target;
      setFilterFn({
        fn: (items) => {
          if (target.value === "") return items;
          else
            return items.filter((x) => {
              if (
                (x.idefiscal !== null && x.idefiscal !== undefined ? x.idefiscal.includes(target.value) : false) ||
                (x.descriptor ? x.descriptor.toLowerCase().includes(target.value.toLowerCase()) : false) ||
                (x.puc ? x.puc.toLowerCase().includes(target.value.toLowerCase()) : false)
              ) {
                return x;
              }
              return false;
            });
        },
      });
    };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let orden = "idefiscal desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        if (error.response) {
          // El servidor respondió con un código de estado fuera del rango 2xx
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        } else if (error.request) {
          // La solicitud fue hecha pero no se recibió respuesta
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "No se recibió respuesta del servidor",
            icono: "error",
          });
        } else {
          // Algo sucedió al configurar la solicitud que desencadenó un error
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Error al realizar la solicitud",
            icono: "error",
          });
        }
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const SelecccionarEfiscal = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idefiscal > 0) {
            setEfiscal(response.data);
            seleccionarOrganizacion(response.data);
          } else {
            setEfiscal();
            seleccionarOrganizacion(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
        } else if (error.request) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "No se recibió respuesta del servidor",
            icono: "error",
          });
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Error al realizar la solicitud",
            icono: "error",
          });
        }
        setActivate(false);
      });
  };
  const seleccionarOrganizacion = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idorganizacion}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idorganizacion > 0) {
            setOrga(response.data);
            setMostrar2(true);
          } else {
            setOrga();
            setMostrar2(true);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionarActuProgramatica = (op, id, per) => (e) => {
    e.preventDefault();
    if (per.toString() === "1") {
      if (op === 4) {
        setOperacion(4);
        SelecccionarEfiscal(id, op);
      } else if (op === 1) {
        setOperacion(op);
        setMostrar2(true);
      } else if (op === 2) {
        setOperacion(op);
        SelecccionarEfiscal(id, op);
      } else if (op === 3) {
        setOperacion(op);
        SelecccionarEfiscal(id, op);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
            ? "No posee permiso para Editar"
            : op === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };
  const cerrar = () => {
    props.menu();
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  return (
    <section className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant">
        <h3 className="fw-bold m-0">Ejercicio Fiscal</h3>
        <a type="button" onClick={cerrar}>
          Salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <SearchInput
            onChange={handleSearch}
            placeholder="Buscar"
            ref={txtBuscador}
          />
        </div>
        <div className="col-auto m-0 p-0">

          <PrimaryButton icon = 'fa-plus m-0'
            onClick={gestionarActuProgramatica(
              1,
              "",
              permiso.toString().substring(1, 2)
            )}
            disabled={permiso.toString().substring(1, 2) !== "1"} 
          >
          </PrimaryButton>
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-middle"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {item.idefiscal}
                  </td>
                  <td
                    className="align-middle"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "350px",
                    }}
                  >
                    {item.descriptor}
                  </td>
                  <td
                    className="align-middle"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {item.anio}
                  </td>

                  <td
                    className="align-middle"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    <button
                      onClick={gestionarActuProgramatica(
                        4,
                        item.idefiscal,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                      style={{
                        padding: '1px'
                      }}
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <button
                      onClick={gestionarActuProgramatica(
                        2,
                        item.idefiscal,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <button
                      onClick={gestionarActuProgramatica(
                        3,
                        item.idefiscal,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ActualizarEfiscal
        show={mostrar2}
        operacion={operacion}
        fiscal={efiscal}
        organiza={orga}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </section>
  );
};
export default TablaEjFisca2;
